import icon from "@/assets/logo-icon-t.png";

export default function GearMark({ size = 28, className = "", style }) {
  return (
    <img
      src={icon}
      alt="Transactr gear mark"
      width={size}
      height={size}
      draggable="false"
      style={style}
      className={`select-none ${className}`}
    />
  );
}
